import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// English translations
import enAdmin from "../locales/en/admin.json";
import enChallenges from "../locales/en/challenges.json";
import enContact from "../locales/en/contact.json";
import enGuestGallery from "../locales/en/guestgallery.json";
import enHighscores from "../locales/en/highscores.json";
import enHome from "../locales/en/home.json";
import enIntro from "../locales/en/intro.json";
import enNewTeam from "../locales/en/newteam.json";
import enRegister from "../locales/en/register.json";
import enSelect from "../locales/en/select.json";
import enSelectTeam from "../locales/en/selectteam.json";
import enTeams from "../locales/en/teams.json";
import enTeamSettings from "../locales/en/teamsettings.json";
import enUpload from "../locales/en/upload.json";
import enCookieConsent from "../locales/en/cookieconsent.json";

// Lithuanian translations
import ltAdmin from "../locales/lt/admin.json";
import ltChallenges from "../locales/lt/challenges.json";
import ltContact from "../locales/lt/contact.json";
import ltGuestGallery from "../locales/lt/guestgallery.json";
import ltHighscores from "../locales/lt/highscores.json";
import ltHome from "../locales/lt/home.json";
import ltIntro from "../locales/lt/intro.json";
import ltNewTeam from "../locales/lt/newteam.json";
import ltRegister from "../locales/lt/register.json";
import ltSelect from "../locales/lt/select.json";
import ltSelectTeam from "../locales/lt/selectteam.json";
import ltTeams from "../locales/lt/teams.json";
import ltTeamSettings from "../locales/lt/teamsettings.json";
import ltUpload from "../locales/lt/upload.json";
import ltCookieConsent from "../locales/lt/cookieconsent.json";

// Swedish translations
import svAdmin from "../locales/sv/admin.json";
import svChallenges from "../locales/sv/challenges.json";
import svContact from "../locales/sv/contact.json";
import svGuestGallery from "../locales/sv/guestgallery.json";
import svHighscores from "../locales/sv/highscores.json";
import svHome from "../locales/sv/home.json";
import svIntro from "../locales/sv/intro.json";
import svNewTeam from "../locales/sv/newteam.json";
import svRegister from "../locales/sv/register.json";
import svSelect from "../locales/sv/select.json";
import svSelectTeam from "../locales/sv/selectteam.json";
import svTeams from "../locales/sv/teams.json";
import svTeamSettings from "../locales/sv/teamsettings.json";
import svUpload from "../locales/sv/upload.json";
import svCookieConsent from "../locales/sv/cookieconsent.json";

// German translations
import deAdmin from "../locales/de/admin.json";
import deChallenges from "../locales/de/challenges.json";
import deContact from "../locales/de/contact.json";
import deGuestGallery from "../locales/de/guestgallery.json";
import deHighscores from "../locales/de/highscores.json";
import deHome from "../locales/de/home.json";
import deIntro from "../locales/de/intro.json";
import deNewTeam from "../locales/de/newteam.json";
import deRegister from "../locales/de/register.json";
import deSelect from "../locales/de/select.json";
import deSelectTeam from "../locales/de/selectteam.json";
import deTeams from "../locales/de/teams.json";
import deTeamSettings from "../locales/de/teamsettings.json";
import deUpload from "../locales/de/upload.json";
import deCookieConsent from "../locales/de/cookieconsent.json";

// Spanish translations
import esAdmin from "../locales/es/admin.json";
import esChallenges from "../locales/es/challenges.json";
import esContact from "../locales/es/contact.json";
import esGuestGallery from "../locales/es/guestgallery.json";
import esHighscores from "../locales/es/highscores.json";
import esHome from "../locales/es/home.json";
import esIntro from "../locales/es/intro.json";
import esNewTeam from "../locales/es/newteam.json";
import esRegister from "../locales/es/register.json";
import esSelect from "../locales/es/select.json";
import esSelectTeam from "../locales/es/selectteam.json";
import esTeams from "../locales/es/teams.json";
import esTeamSettings from "../locales/es/teamsettings.json";
import esUpload from "../locales/es/upload.json";
import esCookieConsent from "../locales/es/cookieconsent.json";

// Italian translations
import itAdmin from "../locales/it/admin.json";
import itChallenges from "../locales/it/challenges.json";
import itContact from "../locales/it/contact.json";
import itGuestGallery from "../locales/it/guestgallery.json";
import itHighscores from "../locales/it/highscores.json";
import itHome from "../locales/it/home.json";
import itIntro from "../locales/it/intro.json";
import itNewTeam from "../locales/it/newteam.json";
import itRegister from "../locales/it/register.json";
import itSelect from "../locales/it/select.json";
import itSelectTeam from "../locales/it/selectteam.json";
import itTeams from "../locales/it/teams.json";
import itTeamSettings from "../locales/it/teamsettings.json";
import itUpload from "../locales/it/upload.json";
import itCookieConsent from "../locales/it/cookieconsent.json";

// French translations
import frAdmin from "../locales/fr/admin.json";
import frChallenges from "../locales/fr/challenges.json";
import frContact from "../locales/fr/contact.json";
import frGuestGallery from "../locales/fr/guestgallery.json";
import frHighscores from "../locales/fr/highscores.json";
import frHome from "../locales/fr/home.json";
import frIntro from "../locales/fr/intro.json";
import frNewTeam from "../locales/fr/newteam.json";
import frRegister from "../locales/fr/register.json";
import frSelect from "../locales/fr/select.json";
import frSelectTeam from "../locales/fr/selectteam.json";
import frTeams from "../locales/fr/teams.json";
import frTeamSettings from "../locales/fr/teamsettings.json";
import frUpload from "../locales/fr/upload.json";
import frCookieConsent from "../locales/fr/cookieconsent.json";

// Polish translations
import plAdmin from "../locales/pl/admin.json";
import plChallenges from "../locales/pl/challenges.json";
import plContact from "../locales/pl/contact.json";
import plGuestGallery from "../locales/pl/guestgallery.json";
import plHighscores from "../locales/pl/highscores.json";
import plHome from "../locales/pl/home.json";
import plIntro from "../locales/pl/intro.json";
import plNewTeam from "../locales/pl/newteam.json";
import plRegister from "../locales/pl/register.json";
import plSelect from "../locales/pl/select.json";
import plSelectTeam from "../locales/pl/selectteam.json";
import plTeams from "../locales/pl/teams.json";
import plTeamSettings from "../locales/pl/teamsettings.json";
import plUpload from "../locales/pl/upload.json";
import plCookieConsent from "../locales/pl/cookieconsent.json";

// Latvian translations
import lvAdmin from "../locales/lv/admin.json";
import lvChallenges from "../locales/lv/challenges.json";
import lvContact from "../locales/lv/contact.json";
import lvGuestGallery from "../locales/lv/guestgallery.json";
import lvHighscores from "../locales/lv/highscores.json";
import lvHome from "../locales/lv/home.json";
import lvIntro from "../locales/lv/intro.json";
import lvNewTeam from "../locales/lv/newteam.json";
import lvRegister from "../locales/lv/register.json";
import lvSelect from "../locales/lv/select.json";
import lvSelectTeam from "../locales/lv/selectteam.json";
import lvTeams from "../locales/lv/teams.json";
import lvTeamSettings from "../locales/lv/teamsettings.json";
import lvUpload from "../locales/lv/upload.json";
import lvCookieConsent from "../locales/lv/cookieconsent.json";

// Portuguese (Brazilian) translations
import ptAdmin from "../locales/pt/admin.json";
import ptChallenges from "../locales/pt/challenges.json";
import ptContact from "../locales/pt/contact.json";
import ptGuestGallery from "../locales/pt/guestgallery.json";
import ptHighscores from "../locales/pt/highscores.json";
import ptHome from "../locales/pt/home.json";
import ptIntro from "../locales/pt/intro.json";
import ptNewTeam from "../locales/pt/newteam.json";
import ptRegister from "../locales/pt/register.json";
import ptSelect from "../locales/pt/select.json";
import ptSelectTeam from "../locales/pt/selectteam.json";
import ptTeams from "../locales/pt/teams.json";
import ptTeamSettings from "../locales/pt/teamsettings.json";
import ptUpload from "../locales/pt/upload.json";
import ptCookieConsent from "../locales/pt/cookieconsent.json";

// Simplified Chinese translations
import zhAdmin from "../locales/zh/admin.json";
import zhChallenges from "../locales/zh/challenges.json";
import zhContact from "../locales/zh/contact.json";
import zhGuestGallery from "../locales/zh/guestgallery.json";
import zhHighscores from "../locales/zh/highscores.json";
import zhHome from "../locales/zh/home.json";
import zhIntro from "../locales/zh/intro.json";
import zhNewTeam from "../locales/zh/newteam.json";
import zhRegister from "../locales/zh/register.json";
import zhSelect from "../locales/zh/select.json";
import zhSelectTeam from "../locales/zh/selectteam.json";
import zhTeams from "../locales/zh/teams.json";
import zhTeamSettings from "../locales/zh/teamsettings.json";
import zhUpload from "../locales/zh/upload.json";
import zhCookieConsent from "../locales/zh/cookieconsent.json";

// Helper function to create language resource object
const createLanguageResource = (modules: Record<string, object>) => ({
  admin: modules.admin,
  challenges: modules.challenges,
  contact: modules.contact,
  guestgallery: modules.guestgallery,
  highscores: modules.highscores,
  home: modules.home,
  intro: modules.intro,
  newteam: modules.newteam,
  register: modules.register,
  select: modules.select,
  selectteam: modules.selectteam,
  teams: modules.teams,
  teamsettings: modules.teamsettings,
  upload: modules.upload,
  cookieconsent: modules.cookieconsent,
});

// Read stored locale synchronously before init to prevent English flash
const getInitialLocale = (): AppLocale => {
  try {
    // Parse eventId from URL path (first segment after /)
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const eventId = pathSegments[0];

    if (eventId) {
      const stored = window.localStorage.getItem(`camdeed-locale-${eventId}`);
      if (stored) return stored as AppLocale;

      // Check old appData for migration
      const appDataKey = `camdeed-app-v1.1-${eventId}`;
      const raw = window.localStorage.getItem(appDataKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed.locale) return parsed.locale as AppLocale;
      }
    }
  } catch {
    // localStorage unavailable or parse error
  }

  // Brand-based default
  const href = window.location.href;
  const isCamdeed =
    href.includes("localhost") ||
    href.includes("127.0.0.1") ||
    href.includes("camdeed.app") ||
    href.includes("camdeed.com");
  return isCamdeed ? "en" : "lt";
};

// Initialize i18n with all language resources
i18n.use(initReactI18next).init({
  resources: {
    en: createLanguageResource({
      admin: enAdmin,
      challenges: enChallenges,
      contact: enContact,
      guestgallery: enGuestGallery,
      highscores: enHighscores,
      home: enHome,
      intro: enIntro,
      newteam: enNewTeam,
      register: enRegister,
      select: enSelect,
      selectteam: enSelectTeam,
      teams: enTeams,
      teamsettings: enTeamSettings,
      upload: enUpload,
      cookieconsent: enCookieConsent,
    }),
    lt: createLanguageResource({
      admin: ltAdmin,
      challenges: ltChallenges,
      contact: ltContact,
      guestgallery: ltGuestGallery,
      highscores: ltHighscores,
      home: ltHome,
      intro: ltIntro,
      newteam: ltNewTeam,
      register: ltRegister,
      select: ltSelect,
      selectteam: ltSelectTeam,
      teams: ltTeams,
      teamsettings: ltTeamSettings,
      upload: ltUpload,
      cookieconsent: ltCookieConsent,
    }),
    sv: createLanguageResource({
      admin: svAdmin,
      challenges: svChallenges,
      contact: svContact,
      guestgallery: svGuestGallery,
      highscores: svHighscores,
      home: svHome,
      intro: svIntro,
      newteam: svNewTeam,
      register: svRegister,
      select: svSelect,
      selectteam: svSelectTeam,
      teams: svTeams,
      teamsettings: svTeamSettings,
      upload: svUpload,
      cookieconsent: svCookieConsent,
    }),
    de: createLanguageResource({
      admin: deAdmin,
      challenges: deChallenges,
      contact: deContact,
      guestgallery: deGuestGallery,
      highscores: deHighscores,
      home: deHome,
      intro: deIntro,
      newteam: deNewTeam,
      register: deRegister,
      select: deSelect,
      selectteam: deSelectTeam,
      teams: deTeams,
      teamsettings: deTeamSettings,
      upload: deUpload,
      cookieconsent: deCookieConsent,
    }),
    es: createLanguageResource({
      admin: esAdmin,
      challenges: esChallenges,
      contact: esContact,
      guestgallery: esGuestGallery,
      highscores: esHighscores,
      home: esHome,
      intro: esIntro,
      newteam: esNewTeam,
      register: esRegister,
      select: esSelect,
      selectteam: esSelectTeam,
      teams: esTeams,
      teamsettings: esTeamSettings,
      upload: esUpload,
      cookieconsent: esCookieConsent,
    }),
    it: createLanguageResource({
      admin: itAdmin,
      challenges: itChallenges,
      contact: itContact,
      guestgallery: itGuestGallery,
      highscores: itHighscores,
      home: itHome,
      intro: itIntro,
      newteam: itNewTeam,
      register: itRegister,
      select: itSelect,
      selectteam: itSelectTeam,
      teams: itTeams,
      teamsettings: itTeamSettings,
      upload: itUpload,
      cookieconsent: itCookieConsent,
    }),
    fr: createLanguageResource({
      admin: frAdmin,
      challenges: frChallenges,
      contact: frContact,
      guestgallery: frGuestGallery,
      highscores: frHighscores,
      home: frHome,
      intro: frIntro,
      newteam: frNewTeam,
      register: frRegister,
      select: frSelect,
      selectteam: frSelectTeam,
      teams: frTeams,
      teamsettings: frTeamSettings,
      upload: frUpload,
      cookieconsent: frCookieConsent,
    }),
    pl: createLanguageResource({
      admin: plAdmin,
      challenges: plChallenges,
      contact: plContact,
      guestgallery: plGuestGallery,
      highscores: plHighscores,
      home: plHome,
      intro: plIntro,
      newteam: plNewTeam,
      register: plRegister,
      select: plSelect,
      selectteam: plSelectTeam,
      teams: plTeams,
      teamsettings: plTeamSettings,
      upload: plUpload,
      cookieconsent: plCookieConsent,
    }),
    lv: createLanguageResource({
      admin: lvAdmin,
      challenges: lvChallenges,
      contact: lvContact,
      guestgallery: lvGuestGallery,
      highscores: lvHighscores,
      home: lvHome,
      intro: lvIntro,
      newteam: lvNewTeam,
      register: lvRegister,
      select: lvSelect,
      selectteam: lvSelectTeam,
      teams: lvTeams,
      teamsettings: lvTeamSettings,
      upload: lvUpload,
      cookieconsent: lvCookieConsent,
    }),
    pt: createLanguageResource({
      admin: ptAdmin,
      challenges: ptChallenges,
      contact: ptContact,
      guestgallery: ptGuestGallery,
      highscores: ptHighscores,
      home: ptHome,
      intro: ptIntro,
      newteam: ptNewTeam,
      register: ptRegister,
      select: ptSelect,
      selectteam: ptSelectTeam,
      teams: ptTeams,
      teamsettings: ptTeamSettings,
      upload: ptUpload,
      cookieconsent: ptCookieConsent,
    }),
    zh: createLanguageResource({
      admin: zhAdmin,
      challenges: zhChallenges,
      contact: zhContact,
      guestgallery: zhGuestGallery,
      highscores: zhHighscores,
      home: zhHome,
      intro: zhIntro,
      newteam: zhNewTeam,
      register: zhRegister,
      select: zhSelect,
      selectteam: zhSelectTeam,
      teams: zhTeams,
      teamsettings: zhTeamSettings,
      upload: zhUpload,
      cookieconsent: zhCookieConsent,
    }),
  },
  lng: getInitialLocale(),
  fallbackLng: "en", // Fallback to English if a translation for the current language is missing
  interpolation: { escapeValue: false }, // Disable HTML escaping
});

// Keep <html lang> in sync so browsers pick the right glyphs (matters for CJK) and screen
// readers announce the correct language. index.html ships a static lang="en".
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export default i18n;
